import { Link } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { Button } from '@mehir/web-ui/button';
import { Card, CardContent } from '@mehir/web-ui/card';
import { ScreenHeader } from './screen-state';

interface PendingPageProps {
  title: string;
}

/**
 * Stands in for a page whose sidebar entry is deliberately disabled.
 *
 * Greying the link out only stops the click — the route was still live, so
 * typing the URL (or following an old bookmark) opened a screen that either
 * duplicated another list or sat empty against an endpoint that does not
 * exist. The reasons are kept in one place, Ayarlar › Sürüm Notları.
 */
export const PendingPage = ({ title }: PendingPageProps) => (
  <div className="container mx-auto p-6">
    <ScreenHeader icon={Construction} title={title} />
    <Card>
      <CardContent className="p-6">
        <div className="py-12 text-center">
          <Construction className="mx-auto mb-4 h-12 w-12 text-muted-foreground" />
          <h3 className="mb-2 text-lg font-semibold">Bu sayfa henüz hazır değil</h3>
          <p className="mx-auto mb-6 max-w-md text-sm text-muted-foreground">
            Menüde soluk görünmesinin sebebi bu. Neyi beklediği ve ne zaman açılacağı Sürüm
            Notları sayfasında yazıyor.
          </p>
          <Button asChild variant="outline">
            <Link to="/changelog">Sürüm Notları</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  </div>
);
